<div class="trends-card analytics-card-host" [class.is-refreshing]="isLoading()">
  <div class="trends-header">
    <h3 class="trends-title">Activity Trends</h3>
    <div class="header-right">
      <div class="trends-legend">
        <div class="legend-item" *ngFor="let item of legendItems">
          <span class="legend-dot" [style.background]="item.color"></span>
          <span class="legend-label">{{ item.label }}</span>
        </div>
      </div>
      <div class="granularity-toggle">
        <button [class.active]="granularity() === 'DAY'" (click)="onGranularityChange('DAY')">Day</button>
        <button [class.active]="granularity() === 'WEEK'" (click)="onGranularityChange('WEEK')">Week</button>
        <button [class.active]="granularity() === 'MONTH'" (click)="onGranularityChange('MONTH')">Month</button>
      </div>
    </div>
  </div>
  <div class="chart-container">
    <ngx-charts-line-chart
      [results]="chartData()"
      [scheme]="colorScheme"
      [xAxis]="true"
      [yAxis]="true"
      [showXAxisLabel]="false"
      [showYAxisLabel]="false"
      [autoScale]="true"
      [gradient]="true"
      [animations]="true"
      [xAxisTickFormatting]="formatXAxisTick">
    </ngx-charts-line-chart>
  </div>
</div>
